import { Box, Skeleton } from '@mui/material'
import { GridColumns } from '@mui/x-data-grid-pro'

import React from 'react'
import { v4 } from 'uuid'
import XGrid from '../../XGrid/XGrid'
interface Props {
  columns: GridColumns
  rowsPerPage?: number
}
const DataGridSkeleton: ReactFC<Props> = (props) => {
  const columns = props.columns.map((column, index) => ({
    ...column,
    valueFormatter: undefined,
    field: `${index}`,
    renderHeader: () => (
      <Skeleton
        width='100%'
        variant='text'
        animation='wave'
      />
    ),
    renderCell: () => {
      return (
        <Skeleton
          width='100%'
          variant='text'
          animation='wave'
        />
      )
    }
  }))

  const skeletonRow = columns.reduce<any>((acum, column) => {
    acum[`${column.field}`] = {
      field: 'field'
    }
    return acum
  }, {
  })

  const skeletonRows = Array(props.rowsPerPage ?? 5)
    .fill(undefined)
    .map(() => ({
      id: v4(), ...skeletonRow
    }))

  return (
    <XGrid
      rows={skeletonRows}
      columns={columns}
      pageSize={props.rowsPerPage ?? 5}
      disableSelectionOnClick
      disableMultipleSelection
      autoHeight
      pagination
      components={{
        Pagination: () => (
          <Box pr='1rem'>
            <Skeleton
              height='2rem'
              width='15rem'
              variant='rectangular'
            />
          </Box>
        )
      }}
    />
  )
}
export default DataGridSkeleton
